
const m = window.require("@simple-dom/document");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
